import React from 'react';
import PropTypes from 'prop-types';
import UserCard2 from 'components/Shared/UserCard2/UserCard2';
import Panel from 'components/Panel/Panel';
import userCardStyles from 'components/Shared/UserCard2/UserCard2.module.scss';

const BrowseUserCard2 = ({
  collaborations,
  onInvite,
  user,
  preferredRole,
  isLoadingOwnBriefs,
}) => {
  return (
    <Panel className={userCardStyles.gridContainer}>
      <UserCard2
        collaborations={collaborations}
        onInvite={onInvite}
        user={user}
        preferredRole={preferredRole}
        isLoadingOwnBriefs={isLoadingOwnBriefs}
      />
    </Panel>
  );
};

BrowseUserCard2.propTypes = {
  collaborations: PropTypes.array,
  onInvite: PropTypes.func,
  user: PropTypes.object,
  preferredRole: PropTypes.string,
  isLoadingOwnBriefs: PropTypes.bool,
};

export default BrowseUserCard2;
